import store from '../store/store';
// require('./interceptors')

export const middleware = router => {
  /**
   * Get Route Access
   */
  router.beforeEach((to, from, next) => {
    store.dispatch('apiRoute/routeTo', to);
    next();
  });
  /**
   * Verifica se esta logado no sistema
   */
  router.beforeEach((to, from, next) => {
    const isAuth = to.matched.some(record => record.meta.isLogin);
    const userIsAuth = window.localStorage.getItem('access_token');
    if (isAuth && !userIsAuth) {
      next('/login');
    } else {
      next();
    }

    // Check Access Token
    // store.dispatch('auth/authenticate', {}, { root: true })
    //   .then(response => {
    //     console.log(store)
    //     next()
    //   })
  });
};
